import React from 'react';
import {Card} from 'semantic-ui-react';
import {EmpyDataIcon} from '../../../icons/EmpyDataIcon';
import './styles.scss';

export const EmptyDataCard = () => {
  return (
    <Card raised fluid className='floating-empty-data'>
      <EmpyDataIcon />
      <p>No se ha encontrado información.</p>
    </Card>
  );
};
